module.exports = __webpack_public_path__ + "static/img/pingji yinzhang.c8015da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pingji yinzhang.png
// module id = QZRw
// module chunks = 26